import React, { useEffect, useState } from "react";
import { orderDetails, getProduct } from "../../services/Api";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getImageProduct } from "../../shared/ultils";
import moment from "moment";
const OrderDetails = () => {
  const { id } = useParams();
  //B1: gọi API orderDetails để lấy ra thông tin đơn hàng đã mua, data.data trả về một object {}
  //trong {} đó có ---> _id (ID đơn hàng), totalPrice, status
  //và items [{},{},...], trong items lại có ---> prd_id (product ID), qty (số lượng), price
  //
  //B2: gọi API getProduct để bổ sung thêm thumbnail, name vào items:

  const customerLogged = useSelector(({ auth }) => auth.login);
  const [order_totalPrice, setOrder_totalPrice] = useState(0);
  const [listItems, setListItems] = useState([]);
  const [listNewItems, setListNewItems] = useState([]); //để bổ sung thêm thumbnail, name
  const fetchDataA = async () => {
    const responseA = await orderDetails(
      id,
      customerLogged.currentCustomer.accessToken
    );
    if (responseA.status === 200) {
      //trả về một {}, trong đó đã có totalPrice,
      setOrder_totalPrice(responseA.data.data.totalPrice);
      //{} đó có items là [] chứa các {}, gồm {prd_id, price, qty} chỉ thiếu name, thumbnail
      return setListItems(responseA.data.data.items);
    } else console.log(responseA);
  };
  //-----------------------------------------------------
  const fetchDataB = async (prd_id) => {
    const responseB = await getProduct(prd_id);
    if (responseB.status === 200) {
      //trả về một {},
      return responseB.data.data;
    } else console.log(responseB);
  };
  useEffect(() => {
    fetchDataA();
    if (listItems) {
      //listItems là [] cần bổ sung thêm thumbnail, name
      //từ API getProduct
      let productDetails = {};
      let list_New_Items = [];
      listItems?.map(async (item) => {
        productDetails = await fetchDataB(item.prd_id);
        //lấy dữ liệu trả về từ Object mới
        //phải dùng biến ko dùng state được
        const { name, thumbnail } = productDetails;
        list_New_Items.push({ ...item, name, thumbnail });
        productDetails = {};
      });
      setListNewItems(list_New_Items);
    }
  }, [id]);

  return (
    <>
      {/*	Order Details	*/}
      <div id="my-cart">
        <div className="row">
          <div className="cart-nav-item col-lg-7 col-md-7 col-sm-12">
            Thông tin sản phẩm
          </div>
          <div className="cart-nav-item col-lg-2 col-md-2 col-sm-12">
            Số lượng
          </div>
          <div className="cart-nav-item col-lg-3 col-md-3 col-sm-12">Giá</div>
        </div>
        <form method="post">
          {listNewItems?.map((item) => {
            return (
              <>
                <div className="cart-item row">
                  <div className="cart-thumb col-lg-7 col-md-7 col-sm-12">
                    <img src={getImageProduct(item.thumbnail)} />
                    <h4>{item.name}</h4>
                  </div>
                  <div className="cart-quantity col-lg-2 col-md-2 col-sm-12">
                    <p>{item.qty}</p>
                  </div>
                  <div className="cart-price col-lg-3 col-md-3 col-sm-12">
                    <b>{Number(item.price).toLocaleString("vi-VN")}đ</b>
                  </div>
                </div>
              </>
            );
          })}
          <div className="row">
            <div className="cart-thumb col-lg-7 col-md-7 col-sm-12"></div>
            <div className="cart-total col-lg-2 col-md-2 col-sm-12">
              <b>Tổng cộng:</b>
            </div>
            <div className="cart-price col-lg-3 col-md-3 col-sm-12">
              <b>{Number(order_totalPrice).toLocaleString("vi-VN")}đ</b>
            </div>
          </div>
        </form>
      </div>
      {/*	End Order Details	*/}
      {/*	Customer Info	*/}
      <div id="customer">
        <div className="row">
          <div className="by-now col-lg-6 col-md-6 col-sm-12">
            <a href="/OrderList">
              <b>Về danh sách đơn hàng</b>
            </a>
          </div>
          <div className="by-now col-lg-6 col-md-6 col-sm-12">
            <a href="/">
              <b>Về trang chủ</b>
            </a>
          </div>
        </div>
      </div>
      {/*	End Customer Info	*/}
    </>
  );
};
//   const [dataA, setDataA] = useState({});
//   const [dataB, setDataB] = useState({});
//   const { id } = useParams();

//   const fetchDataB = async (prd_id) => {
//     const responseB = await getProduct(prd_id);
//     if (responseB.status === 200) {
//       let temp = responseB.data.data;
//       const { name, thumbnail } = temp;
//       // console.log("name");
//       // console.log(name);
//       // console.log("thumbnail");
//       // console.log(thumbnail);
//       return setDataB({ name, thumbnail });
//     }
//   };
//   const fetchDataA = async () => {
//     const responseA = await orderDetails(id);
//     console.log("responseA.data.data");
//     console.log(responseA.data.data); //OK
//     if (responseA.status === 200) {
//       let tempItems = [];
//       responseA.data.data.items?.map(async (item, index) => {
//         await fetchDataB(item.prd_id);
//         console.log("dataB");
//         console.log(dataB);
//         const { name, thumbnail } = dataB;
//         tempItems.push({ ...item, name: name, thumbnail: thumbnail });
//       });
//       responseA.data.data.items = tempItems; //gán đè có bổ sung thông tin
//       return setDataA(responseA.data.data);
//     }
//   };

//   useEffect(() => {
//     fetchDataA();
//     //------------------------------
//     // orderDetails(id)
//     //   .then(({ data }) => {
//     //     setData(data.data);
//     //   })
//     //   .catch((error) => console.log(error));
//   }, [id]);
//   return (
//     <>
//       {/*	Order Details	*/}
//       <div id="my-cart">
//         <div className="row">
//           <div className="cart-nav-item col-lg-7 col-md-7 col-sm-12">
//             Thông tin sản phẩm
//           </div>
//           <div className="cart-nav-item col-lg-2 col-md-2 col-sm-12">
//             Số lượng
//           </div>
//           <div className="cart-nav-item col-lg-3 col-md-3 col-sm-12">Giá</div>
//         </div>
//         <form method="post">
//           {dataA.items?.map((item, index) => {
//             console.log("item inner JSX");
//             console.log(item);
//             return (
//               <>
//                 <div className="cart-item row">
//                   <div className="cart-thumb col-lg-7 col-md-7 col-sm-12">
//                     <img src={getImageProduct(item?.thumbnail)} />
//                     <h4>{item?.name}</h4>
//                   </div>
//                   <div className="cart-quantity col-lg-2 col-md-2 col-sm-12">
//                     <p>{item.qty}</p>
//                   </div>
//                   <div className="cart-price col-lg-3 col-md-3 col-sm-12">
//                     <b>
//                       {Number(item.qty * item.price).toLocaleString("vi-Vn")}đ
//                     </b>
//                   </div>
//                 </div>
//               </>
//             );
//           })}

//           <div className="row">
//             <div className="cart-thumb col-lg-7 col-md-7 col-sm-12"></div>
//             <div className="cart-total col-lg-2 col-md-2 col-sm-12">
//               <b>Tổng cộng:</b>
//             </div>
//             <div className="cart-price col-lg-3 col-md-3 col-sm-12">
//               <b>{Number(dataA.totalPrice).toLocaleString("vi-Vn")}đ</b>
//             </div>
//           </div>
//         </form>
//       </div>
//       {/*	End Order Details	*/}
//     </>
//   );
// };
export default OrderDetails;
